import { type Color, type MoveEvent, WHITE, frozenQueens, frozenTurns, other, pieceColor } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const ICE = '/art/wQ-ice.svg';
const fx = (e: MoveEvent, kind: string) => e.t === 'fx' && e.kind === kind;

export const cooldownUi: VariantUi = {
  heroImage: ICE,
  peek: [{}, { image: '/art/bK.svg' }, {}, {}, {}, {}, { image: ICE, threat: true }, {}, { image: '/art/wK.svg' }],

  pieceImage(_pos, _sq, piece) {
    if (!frozenTurns(piece)) return null;
    return `/art/${pieceColor(piece) === WHITE ? 'w' : 'b'}Q-ice.svg`;
  },

  pieceLabel(_pos, _sq, piece) {
    const n = frozenTurns(piece);
    if (!n) return null;
    return `${pieceColor(piece) === WHITE ? 'white' : 'black'} queen, frozen for ${n} more ${n === 1 ? 'turn' : 'turns'}`;
  },

  decorations(pos) {
    const out: Decoration[] = [];
    for (const c of [0, 1] as const) {
      for (const sq of frozenQueens(pos.board, c)) out.push({ kind: 'badge', sq, text: String(frozenTurns(pos.board[sq])), tone: 'normal' });
    }
    return out;
  },

  twist(pos, you) {
    // Your queen, or for spectators and pass & play whichever side has one resting.
    const sides: Color[] = you !== null ? [you] : [pos.turn, other(pos.turn)];
    for (const c of sides) {
      const frozen = frozenQueens(pos.board, c);
      if (!frozen.length) continue;
      // Turns count down at the end of the owner's moves, so on your turn "1" means this one.
      const n = Math.max(...frozen.map((sq) => frozenTurns(pos.board[sq])));
      const whose = you !== null ? 'Your' : c === WHITE ? 'White’s' : 'Black’s';
      return {
        text: n === 1 && pos.turn === c ? `${whose} queen thaws after this move` : `${whose} queen is frozen for ${n} more ${n === 1 ? 'turn' : 'turns'}`,
        pips: { on: 2 - n, total: 2, title: 'Turns until the queen thaws' },
      };
    }
    return { text: 'Move a queen and she freezes for your next 2 turns' };
  },

  eventSound(e) {
    return fx(e, 'freeze') ? 'freeze' : fx(e, 'thaw') ? 'thaw' : null;
  },

  moveBadge(rec) {
    if (rec.events.some((e) => fx(e, 'freeze'))) return { icon: `/art/${rec.color === WHITE ? 'w' : 'b'}Q-ice.svg`, title: 'Queen frozen for 2 turns' };
    if (rec.events.some((e) => fx(e, 'thaw'))) return { icon: `/art/${rec.color === WHITE ? 'w' : 'b'}Q.svg`, title: 'Queen thawed' };
    return null;
  },
};
